import { getAccessTokenLocalStorage } from "src/utils/localStorageApi";

export const tokenHeader = () => {
  const token = getAccessTokenLocalStorage();
  const authorization = { Authorization: `Token ${token}` };
  const header = token ? authorization : {};
  return header;
};
